import { render } from "./FarmListEditTroops.vue?vue&type=template&id=683cbf96"
import script from "./FarmListEditTroops.vue?vue&type=script&lang=js"
export * from "./FarmListEditTroops.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/area/windowOverlay/FarmListEditTroops.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "683cbf96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('683cbf96', __exports__)) {
    api.reload('683cbf96', __exports__)
  }
  
  module.hot.accept("./FarmListEditTroops.vue?vue&type=template&id=683cbf96", () => {
    api.rerender('683cbf96', render)
  })

}


export default __exports__